module.exports = __webpack_public_path__ + "img/@awards_img_01_m.9d937ea0.jpg";